const MessageContainerPrefixId = `mx-message-container`;

export { MessageContainerPrefixId };
